module.exports = __webpack_public_path__ + "img/screen_3.d5d8d700.png";